import deliveryManifestAllComponent from './delivery_manifest_all.component';

let deliveryManifestAllModule = angular.module('deliveryManifestAll', [])

    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $urlRouterProvider.otherwise('/routeControl')

        $stateProvider.state('deliveryManifestAll', {
            url: '/delivery-manifest-all',
            component: 'deliveryManifestAll',
            data: {
                requireLogin: true,
                requireACL: 'route_control.all'
            },
        })

    })

    .component("deliveryManifestAll", deliveryManifestAllComponent)

    .name;

export default deliveryManifestAllModule;


// WEBPACK FOOTER //
// ./client/app/components/route_control/delivery_manifest_all/index.js